// extracted by css-extract-rspack-plugin
export default {"card":"TfjTHs5k670NalHn","default":"P2pMjNtcQecejO9l","compact":"usmKeVGUgO_YzIZz","destructive":"UJVBxlyLdV8n0rhy","edgy":"LfVwb_A1uYrq11HO"};